export default __webpack_public_path__ + "static/media/discord.0cd0e157.svg";